import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import * as actions from '../../../store/actions';
import formatters from "../../../utils/forms/formatters";
import validators from "../../../utils/forms/validators";
import AlertCard from "../../theme/cards/AlertCard";
import Input from "../../theme/forms/Input";


function TaxInputForm({ onNoTax }) {
    let inputs = useSelector(state => state.formFlow.inputs)
    let improvements = useSelector(state => state.formFlow.inputs?.improvements || [])
    let optionData = useSelector(state => state.indicativeOptionData)

    let ITCImprovement = useSelector(state => {
        let ITCImp;
        improvements.forEach((imp) => {
            if (ITCImp) return;
            let matchingImp = optionData.improvements.find(d => d.id === imp.id)
            if (matchingImp.tax_benefit_percentage) {
                ITCImp = {...imp, ...matchingImp}
            }

        })
        return ITCImp || {}
    })

    // let [ITCImprovement, setITCImprovement] = useState({})

    let [taxValue, setTaxValue] = useState(0);

    let dispatch = useDispatch();

    let assettype = optionData.assetTypes.find(
        (d) => d.id === +inputs.asset_type
    ) || {};

    let {direct_pay_eligible} = assettype;

    const updateProject = (data) => {
        dispatch(actions.formFlow.updateFormFlowInputs(data))
    }

    const updateITCImprovementInStore = (data) => {
        dispatch(actions.formFlow.updateFormFlowInputs({
            improvements: improvements.map(d => d.id === ITCImprovement.id ?  {...d, ...data} : d)
        }))
    }



    useEffect(() => {

        let tax_v = 0;
        let improvement_value = +ITCImprovement.value

        if (ITCImprovement) {

            if (ITCImprovement.tax_benefit_fixed_subsidy) {
                tax_v += +ITCImprovement.tax_benefit_fixed_subsidy + inputs.additionalGrants;
            }

            if (ITCImprovement.tax_benefit_percentage && !isNaN(improvement_value)) {
                const tax_percentage = (+ITCImprovement.tax_benefit_percentage +
                    (inputs.lowIncomeITCAdderValue || 0) + (inputs.energyITCAdderValue || 0) + (inputs.domesticITCAdderValue || 0))
                tax_v += improvement_value * (tax_percentage / 100);
                updateITCImprovementInStore({tax_benefit_percentage: tax_percentage});

            }
        }

        setTaxValue(tax_v)

        if (tax_v === 0) {
             onNoTax();
        }

    }, [inputs.additionalGrants, inputs.lowIncomeITCAdderValue, inputs.energyITCAdderValue, inputs.domesticITCAdderValue]);


    if (taxValue === 0) {
         return <></>
    }

    return (
         <div>
             <div className="box">
                 {direct_pay_eligible ?
                     <p>This project is eligible for Direct Pay, a program in which the federal government pays the
                         tax benefits directs to the owner of the improvements.</p> :
                     <p> This project qualifies for an investment tax benefit, or "ITC." This is money that can be
                         deducted from taxes.</p>
                 }
                 <p className="mt-2">The ITC works by combining a basic credit (for {ITCImprovement.name}: {ITCImprovement.tax_benefit_percentage}%)
                     with "adders" that can increase
                     the amount eligible for a credit. <a target="_blank" href="https://blog.cleanfi.com/927-2/" rel="noreferrer">Read about adders on our knowledge base.</a></p>

                 <p className="mt-2 has-text-weight-semibold has-text-primary">Your ITC Value is estimated at: {formatters.USDCurrency.formatter(taxValue)}</p>

             </div>
             <AlertCard type="info" _bgClass="has-background-white">
                 The Value of the ITC affects the financing solution offered because many lenders do not want to outlay money that they believe will be repaid in a short amount of time.
                 If a system owner can't front the ITC value, we can combine short term bridge capital with longer term project financing so the project can begin.
             </AlertCard>


             <div className="box mt-5">
                  <Input
                    type="select"
                    inputClasses="is-medium is-fullwidth"
                    label="Is this project in a designated energy district?"
                    subLabel={<div>
                        10% adder based on project location  -
                        <a
                            href="https://blog.cleanfi.com/is-your-project-in-an-energy-community-for-the-itc-10-adder/"
                            target="_blank" rel="noreferrer"
                        >
                                Read about it and check for yourself
                        </a></div>}
                    options={[
                        {value: 0, display: "This project does not qualify"},
                        {value: 10, display: "This project qualifies"}
                    ]}
                    onChange={v => {
                        updateProject({energyITCAdderValue: +v})
                    }}
                    value={inputs.energyITCAdderValue || 0}
                  />
                 <Input
                     type="select"
                     inputClasses="is-medium is-fullwidth"
                     label="Is this project in a designated low income community, or for low-income housing?"
                     subLabel={<div>
                         10% or 20% adder based on project location  -
                         <a
                             href="https://blog.cleanfi.com/defining-a-low-income-qualifying-community-or-project-2023-allocations/"
                             target="_blank" rel="noreferrer"
                         >
                             Read about it and check for yourself
                         </a></div>}
                     options={[
                         {value: 0, display: "This project does not qualify"},
                         {value: 10, display: "This project qualifies, 10%"},
                         {value: 20, display: "This project qualifies, 20%"}
                     ]}
                     onChange={v => {
                         updateProject({lowIncomeITCAdderValue: +v})
                     }}
                     value={inputs.lowIncomeITCAdderValue || 0}
                 />
                 <Input
                     type="select"
                     inputClasses="is-medium is-fullwidth"
                     label="Does this project qualify for the domestically produced good adder?"
                     subLabel={<div>
                         10% adder for using domestically produced goods  -
                         <a
                             href="https://blog.cleanfi.com/927-2/"
                             target="_blank" rel="noreferrer"
                         >
                             Read about it and check for yourself
                         </a></div>}
                     options={[
                         {value: 0, display: "This project does not qualify"},
                         {value: 10, display: "This project qualifies"},
                     ]}
                     onChange={v => {
                         updateProject({domesticITCAdderValue: +v})
                     }}
                     value={inputs.domesticITCAdderValue || 0}
                 />
                 <Input
                     type="text"
                     inputClasses="is-medium is-fullwidth"
                     label="Are there any outside funds that will become available within one year of project activation, such as USDA REAP grants or rebates??"
                     subLabel={<div>
                         <a
                             href="https://blog.cleanfi.com/reap-grants-from-the-us-dept-of-agriculture-who-where-what-how/"
                             target="_blank" rel="noreferrer"
                         >
                             Read about USDA REAP grants
                         </a></div>}
                     onChange={v => {
                         updateProject({additionalGrants: v})
                     }}
                     value={inputs.additionalGrants || 0}
                     {...validators.isNumber}
                     {...formatters.USDCurrency}
                 />
                 <Input
                     type="select"
                     inputClasses="is-medium is-fullwidth"
                     label="Please select your preferred proposal scenario?"
                     subLabel="Answering no will expand available financing options, but you will have to provide the capital upfront."
                     onChange={v => {
                         updateProject({tax_benefit_request: v})
                     }}
                     value={inputs.tax_benefit_request}
                     {...validators.exists}
                     options={[
                         {
                             value: 'absorb',
                             display: "Project owner will finance those benefits themselves.  Only show financing for net amount (project cost minus above contributions)",
                         },
                         {
                             value: 'w_financing',
                             display:  'Present the funding options that offer short-term bridge capital in combination with long term project financing for the balance of the project amount.',
                         },
                         {
                             value: "long_term",
                             display: 'Offer long-term financing for the entire project',
                         }
                     ]}
                 />

             </div>

         </div>
    )



}


export default TaxInputForm;


// data: {
//     tax_benefit_request: 'w_financing' || 'absorb'
// }